import { Descendant } from "slate";

import {
  EMAIL_DYNAMIC_VARIABLE_REGEX,
  parseEmailDynamicVariableMatch,
} from "@mapmycustomers/shared/util/email/parseEmailDynamicVariables";
import { splitStringByRegExp } from "@mapmycustomers/shared/util/stringUtils";

import ElementType from "../../../type/slate/ElementType";

const deserializeFromString = (value: string): Descendant[] => {
  let children: Descendant[];

  if (!value) {
    children = [{ text: "" }];
  } else {
    children = splitStringByRegExp(value, EMAIL_DYNAMIC_VARIABLE_REGEX).map((part) => {
      switch (part.type) {
        case "text":
          return { text: part.text };
        case "match": {
          const { name, prefix } = parseEmailDynamicVariableMatch(part.match);
          return {
            children: [{ text: "" }],
            name,
            prefix,
            type: ElementType.DYNAMIC_VARIABLE,
            value: part.match[0],
          };
        }
      }
    });
  }

  return [
    {
      children,
      type: ElementType.PARAGRAPH,
    },
  ];
};

export default deserializeFromString;
